import { createAsyncThunk } from "@reduxjs/toolkit";
import { NotificationSlack, ReportSourceType } from "@/services/cloudchipr.api";
import { OneTimeReportType } from "@/components/pages/common/send-report/utils/types/types";
import {
  setOneTimeReportDetails,
  setReportsData,
} from "@/store/reports/reportsSlice";
import { getLabelByBillingSourceType } from "@/components/utils/helpers/getLabelByBillingSourceType";
import { getOneTimeReportMessage } from "@/store/reports/utils/helpers/getOneTimeReportMessage";
import { RootState } from "@/store/store";
import { currentUserEmailSelector } from "@/store/profile/currentUserEmailSelector";

interface InitiateOneTimeReportThunkArgs {
  sourceName: string;
  sourceId: string;
  sourceType: ReportSourceType;
  reportType: OneTimeReportType;
}

export const initiateOneTimeReportThunk = createAsyncThunk(
  "reports/initiateOneTimeReport",
  async (
    {
      sourceName,
      sourceType,
      reportType,
      sourceId,
    }: InitiateOneTimeReportThunkArgs,
    { dispatch, getState },
  ) => {
    const state = getState() as RootState;

    const userEmail = currentUserEmailSelector(state);

    dispatch(
      setReportsData({
        source_type: sourceType,
        source_id: sourceId,
      }),
    );

    if (sourceType === "dashboard") {
      dispatch(
        setOneTimeReportDetails({
          includeExplainAi: false,
        }),
      );
    }

    if (reportType === "email") {
      dispatch(
        setOneTimeReportDetails({
          subject: `Please review the ${sourceName} ${getLabelByBillingSourceType(sourceType, true)}`,
        }),
      );

      dispatch(
        setReportsData({
          emails: {
            to: [],
            custom_message: getOneTimeReportMessage(
              sourceName,
              sourceId,
              sourceType,
              userEmail ?? "",
              reportType,
            ),
          },
        }),
      );
    }

    if (reportType === "slack") {
      dispatch(
        setReportsData({
          notifications: [
            {
              type: "slack",
              custom_message: getOneTimeReportMessage(
                sourceName,
                sourceId,
                sourceType,
                userEmail ?? "",
                reportType,
              ),
            } as NotificationSlack,
          ],
        }),
      );
    }
  },
);
